export default {
  ChannelWarehouseManagement: {
    Header: {
      name: '渠道仓名称',
      code: '渠道仓编码',
      status: '渠道仓状态',
      Add: '新增渠道仓',
    },
    Main: {
      time: '创建时间',
      Operation: '操作',
      ps: '是否删除 ?',
      ps1: '渠道仓操作，是否继续 ?',
    },
    form: {
      Edit: '编辑渠道仓',
      Create: '新增渠道仓',
      Basic: '基本信息',
      name: '渠道仓名称',
      code: '渠道仓编码',
      autoCode: '系统自增',
      ruleName: '请输入渠道仓名称',
    },
  },
};
